import * as React from 'react';

import BatcherSelect, { TBatcherSelect } from './Batcher';
import ListSelect, { TListSelect } from './Simple';
import ColorSelect, { TColorSelect } from './SuperSimple';
import SimpleSelect, { TSimpleSelect } from './Some';

type Select = TListSelect 
    | TColorSelect 
    | TBatcherSelect 
    | TSimpleSelect;

declare module '../Controls/hkt' {
    interface URIControlsToKind {
        'select': Select
    }
}

const Select = React.forwardRef<HTMLInputElement, Select>((p, ref) => {
    switch(p.type){
        case 'batcher': {
            return <BatcherSelect
                ref={ref}
                type={p.type}
                name={p.name}
                onSelect={p.onSelect}
                onAction={p.onAction}
                value={p.value}
                data={p.data}
                disabled={p.disabled}
                placeholder={p.placeholder}
            />
        }
        case 'list': {
            return <ListSelect
                ref={ref}
                type={p.type}
                name={p.name}
                onSelect={p.onSelect}
                value={p.value}
                data={p.data}
                disabled={p.disabled}
                placeholder={p.placeholder}
            />
        }
        case 'color': {
            return <ColorSelect
                type={p.type}
                name={p.name}
                onSelect={p.onSelect}
                value={p.value}
                disabled={p.disabled}
                defaultValue={p.defaultValue}
            />
        }
        case 'simple': {
            return <SimpleSelect
                ref={ref}
                type={p.type}
                name={p.name}
                onSelect={p.onSelect}
                value={p.value}
                data={p.data}
                disabled={p.disabled}
                placeholder={p.placeholder}
            />
        }
    }
});

export default Select;
